/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Form } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Topbar from "../user-topbar/UserTopbar";
import Sidebar from "../user-sidebar/UserSidebar";
import Employee from "../../employees/Employee";
import { URLS } from "../../urls";
import {
  fetchActionsUtil,
  stringifyQueryString,
  useCookie,
} from "../../../utils";
import ModalLoader from "../../ModalLoader";
import { GridIcon, ListIcon, SearchIcon } from "../../icons";
import { EmployeeExports } from "../../employees/EmployeeExports";
import EmployeeTable from "../../employees/EmployeeTable";
import { toast } from "react-toastify";
import CustomPagination from "../../Paginations";
import AllEmployeeTable from "../../employees/AllEmployeeTable";
import { UseQueryData } from "../../UseQueryData";
import NoTableItem from "../../NoTableItem";

const UserEmployeesDirectReport = () => {
  const initialQueryParams = {
    limit: 20,
    page: 1,
    id: "",
    name: "",
    department: "",
    sortBy: "id",
    sortOrder: "asc",
  };

  const branch_id = useCookie("branch_id");
  const userId = useCookie("userId");

  const token = "dummy token";

  const { queryParams, theQueryParams, onChangeInput, setQueryParams } =
    UseQueryData({
      initialQueryParams,
      timer: 1500,
    });

  const [isLoading, setIsLoading] = useState(false);
  const [tableMode, seTableMode] = useState(true);
  const [returnParams, setReturnParams] = useState({
    count: 0,
    endIndex: 0,
    startIndex: 0,
  });
  const [showDisplay, setShowDisplay] = useState("Summary");
  const [state, setState] = useState({
    employees: [], //update this whenever you add/update employee in backend.
    searchEmployeeList: [],
    departments: [],
    employeesStatistics: {
      confirmed: 0,
      trainee: 0,
      probation: 0,
      internship: 0,
      gender: {
        Male: 0,
        Female: 0,
        Others: 0,
      },
    },
  });

  const componentWillMount = async () => {
    try {
      setIsLoading(true);

      const { employeesStatistics } = state;

      const employeeData = fetchActionsUtil(
        `${URLS.backendEmployees}/get/${branch_id}?${stringifyQueryString({
          ...queryParams,
          supervisor: userId,
        })}`,
        "GET",
        token
      );
      const departmentData = fetchActionsUtil(
        `${URLS.backendDepartments}/get/${branch_id}`,
        "GET",
        token
      );

      const [departmentResult, employeeResult] = await Promise.all([
        departmentData,
        employeeData,
      ]);

      const changeEmployeesStatistics = {
        confirmed: 0,
        trainee: 0,
        probation: 0,
        internship: 0,
        gender: {
          Male: 0,
          Female: 0,
          Others: 0,
        },
      };
      if (employeeResult?.allEmployee?.length > 0) {
        setState((el) => ({
          ...el,
          employeesStatistics,
        }));
        employeeResult.allEmployee.forEach((employee) => {
          if (employee?.jobInfo?.status === "Confirmed")
            changeEmployeesStatistics.confirmed += 1;
          else if (employee?.jobInfo?.status === "Trainee")
            changeEmployeesStatistics.trainee += 1;
          else if (employee?.jobInfo?.status === "Probation")
            changeEmployeesStatistics.probation += 1;
          else if (employee?.jobInfo?.status === "Internship")
            changeEmployeesStatistics.internship += 1;

          if (employee?.personalInfo?.gender)
            changeEmployeesStatistics.gender[
              employee?.personalInfo?.gender
            ] += 1;
        });
      }

      setState((el) => ({
        ...el,
        employees: employeeResult.employees,
        searchEmployeeList: employeeResult.employees,
        departments: departmentResult.departments,
        employeesStatistics: changeEmployeesStatistics,
      }));
      setReturnParams({
        count: employeeResult.count,
        endIndex: employeeResult.endIndex,
        startIndex: employeeResult.startIndex,
      });
    } catch (error) {
      console.log(error);
      toast.error("Fetching Error !!!");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      componentWillMount();
    }

    return () => {
      isMounted = false;
    };
  }, [branch_id, queryParams]);

  const dropDownFunction = (qty) => {
    setQueryParams((el) => ({ ...el, limit: qty }));
  };

  const { searchEmployeeList, departments, employeesStatistics } = state;

  return (
    <body>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="robots" content="noindex, nofollow" />
        <title>InvexERP</title>
      </Helmet>
      <div className="main-wrapper">
        <Topbar />
        <Sidebar />
        {/*<!-- Page Wrapper -->*/}
        <div className="page-wrapper">
          {/*<!-- Page Content -->*/}
          <div>
            {/*<!-- Page Title -->*/}

            <div className="add_vacancy  mb-3 d-flex border bg-white align-items-center justify-content-between">
              <div className="w-100 d-flex align-items-center justify-content-between">
                <div className="d-flex flex-column container ">
                  <h3 className="mt-1">Direct Reports</h3>
                  <p className="pb-0 secondary-text">
                    Details from my direct reporters
                  </p>
                </div>

                <div className="d-flex justify-content-end align-items-baseline w-100 mr-3">
                  <div className="d-flex align-items-center">
                    <div
                      className={`mx-2 p-cursor ${
                        tableMode
                          ? "text-ash-main"
                          : "blue-color text-primary-main"
                      }`}
                      onClick={() => seTableMode(false)}
                    >
                      <GridIcon color={tableMode ? null : "#2463ae"} />{" "}
                      <b>Grid</b>
                    </div>
                    <div
                      className={`mx-2 p-cursor ${
                        tableMode
                          ? "blue-color text-primary-main"
                          : "text-ash-main"
                      }`}
                      onClick={() => seTableMode(true)}
                    >
                      <ListIcon color={tableMode ? "#2463ae" : null} />{" "}
                      <b>List</b>
                    </div>
                  </div>

                  <div className="mx-3">
                    <EmployeeExports
                      showSalary={false}
                      queryParams={queryParams}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="my-4">
              <div className="d-flex justify-content-start mx-4">
                <div>
                  <Link to={`${URLS.dashboard}`}>
                    <b>Dashboard</b>
                  </Link>
                </div>
                <span className="mx-2">/</span>
                <div>
                  <p className="text-muted">My direct reporters</p>
                </div>
              </div>
            </div>

            {/*<!-- /Page Title -->*/}
            {/*<!-- Leave Statistics -->*/}
            <section className="stats mx-4">
              <div className="stat">
                <div className="icon icon-1">
                  <i class="fa fa-cubes"></i>
                </div>
                <div className="details">
                  <p>{employeesStatistics?.confirmed}</p>
                  <span className="dashboard-links">Confirmed </span>
                </div>
              </div>

              <div className="stat">
                <div className="icon icon-3">
                  <i class="fa fa-cubes"></i>
                </div>
                <div className="details">
                  <p>{employeesStatistics?.trainee}</p>
                  <span className="dashboard-links">Trainee </span>
                </div>
              </div>

              <div className="stat">
                <div className="icon">
                  <i class="fa fa-cubes"></i>
                </div>
                <div className="details">
                  <p>{employeesStatistics?.probation}</p>
                  <span className="dashboard-links">Probation</span>
                </div>
              </div>

              <div className="stat">
                <div className="icon">
                  <i class="fa fa-cubes"></i>
                </div>
                <div className="details">
                  <p>{returnParams.count}</p>
                  <span className="dashboard-links">Total</span>
                </div>
              </div>
            </section>
            {/*<!-- /Leave Statistics -->*/}

            {/*<!-- Search Filter -->*/}
            <div className="row m-3 mb-0">
              <div className="col-sm-6 col-md-4">
                <div className="search-area">
                  <SearchIcon color="#94A3B8" />
                  <Form.Control
                    placeholder="Search employee ID"
                    aria-label="Search employee ID"
                    value={theQueryParams.id}
                    name="id"
                    onChange={onChangeInput}
                  />
                </div>
              </div>
              <div className="col-sm-6 col-md-4">
                <div className="search-area">
                  <SearchIcon color="#94A3B8" />
                  <Form.Control
                    placeholder="Search employee name"
                    aria-label="Search employee name"
                    value={theQueryParams.name}
                    onChange={onChangeInput}
                    name="name"
                  />
                </div>
              </div>
              <div className="col-sm-6 col-md-3">
                <Form.Control
                  as="select"
                  value={theQueryParams.department}
                  onChange={onChangeInput}
                  name="department"
                >
                  <option value="">Select Department</option>
                  {departments && departments.length
                    ? departments.map((department) => {
                        return (
                          <option value={department._id}>
                            {department.name}
                          </option>
                        );
                      })
                    : null}
                </Form.Control>
              </div>
            </div>

            <div className="mx-4 w-100">
              <div className="d-flex justify-content-between align-items-baseline">
                <div className="d-flex w-100">
                  <div>
                    <label>Sort By : </label>
                    <Form.Control
                      as="select"
                      value={theQueryParams.sortBy}
                      onChange={onChangeInput}
                      name="sortBy"
                    >
                      <option value="">Sort By</option>
                      {[
                        { value: "id", label: "Employee ID" },
                        { value: "first", label: "First Name" },
                        { value: "last", label: "Last Name" },
                      ].map((sort) => {
                        return <option value={sort.value}>{sort.label}</option>;
                      })}
                    </Form.Control>
                  </div>

                  <div className="mx-4">
                    <label>Order By : </label>
                    <Form.Control
                      as="select"
                      value={theQueryParams.sortOrder}
                      onChange={onChangeInput}
                      name="sortOrder"
                    >
                      <option value="">Order By</option>
                      {[
                        { value: "asc", label: "Ascending Order" },
                        { value: "desc", label: "Descending Order" },
                      ].map((sort) => {
                        return <option value={sort.value}>{sort.label}</option>;
                      })}
                    </Form.Control>
                  </div>
                  <div className="mx-4">
                    <label>Report Type: </label>
                    <Form.Control
                      as="select"
                      value={showDisplay}
                      onChange={(e) => setShowDisplay(e.target.value)}
                      name="showDisplay"
                    >
                      {[
                        { value: "Summary", label: "Summary" },
                        { value: "Full", label: "Full" },
                      ].map((display) => {
                        return (
                          <option value={display.value}>{display.label}</option>
                        );
                      })}
                    </Form.Control>
                  </div>
                </div>
              </div>
            </div>
            {searchEmployeeList?.length > 0 ? (
              <div>
                {tableMode ? (
                  <div className="m-4">
                    {showDisplay === "Summary" ? (
                      <EmployeeTable
                        searchEmployeeList={searchEmployeeList}
                        startIndex={returnParams.startIndex}
                        hideActions={true}
                        userLink={true}
                      />
                    ) : (
                      <AllEmployeeTable
                        searchEmployeeList={searchEmployeeList}
                        startIndex={returnParams.startIndex}
                        hideActions={true}
                        userLink={true}
                      />
                    )}
                  </div>
                ) : (
                  <div className="grid-4-1 m-4">
                    {searchEmployeeList?.map((employee) => (
                      <Employee
                        key={employee._id}
                        employee={employee}
                        hideActions={true}
                        userLink={true}
                      />
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <NoTableItem title="No employee found" />
            )}
            <div className="my-4">
              <CustomPagination
                setQueryParams={setQueryParams}
                startIndex={returnParams.startIndex}
                endIndex={returnParams.endIndex}
                count={returnParams.count}
                limit={queryParams.limit}
                page={queryParams.page}
                dropDownFunction={dropDownFunction}
              />
            </div>
          </div>
          {/*<!-- /Page Content -->*/}
          <ModalLoader show={isLoading} />
        </div>
        {/*<!-- /Page Wrapper -->*/}
      </div>
      {/*<!-- /Main Wrapper -->*/} {/* <!-- Sidebar Overlay --> */}
      <div className="sidebar-overlay" data-reff=""></div>
    </body>
  );
};

export default UserEmployeesDirectReport;
